import React, { FunctionComponent, ReactNode } from 'react'
import { View } from 'react-native'

import { LinearGradient } from 'expo-linear-gradient'
import styled, { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../../utils/themes/ThemeProvider'
import { tID } from '../../../utils/utils'

export interface AuroraSectionGradientWrapperProps {
  children: ReactNode
}

const StyledLinearGradient = styled(LinearGradient)`
  width: 100%;
`

export const AuroraSectionGradientWrapper: FunctionComponent<AuroraSectionGradientWrapperProps> = ({ children }) => {
  const theme = useTheme() as AuroraThemeType

  const gradientColors = theme.colors.components.contentSection?.background?.gradient

  if (!theme.isAuroraTheme || !gradientColors) {
    return <View>{children}</View>
  }

  return (
    <StyledLinearGradient
      colors={gradientColors}
      start={{ x: 0.5, y: 0 }}
      end={{ x: 0.5, y: 1 }}
      testID={tID('AuroraSectionGradientWrapper')}
    >
      {children}
    </StyledLinearGradient>
  )
}
